export enum Statuses {
	error = 'error',
	success = 'success',
}
